(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('agreement-valuation', {
            parent: 'entity',
            url: '/agreement-valuation?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.agreementValuation.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/agreement-valuation/agreement-valuations.html',
                    controller: 'AgreementValuationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('agreementValuation');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('agreement-valuation-detail', {
            parent: 'entity',
            url: '/agreement-valuation/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.agreementValuation.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/agreement-valuation/agreement-valuation-detail.html',
                    controller: 'AgreementValuationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('agreementValuation');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AgreementValuation', function($stateParams, AgreementValuation) {
                    return AgreementValuation.get({id : $stateParams.id});
                }]
            }
        })
        .state('agreement-valuation.new', {
            parent: 'agreement-valuation',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/agreement-valuation/agreement-valuation-dialog.html',
                    controller: 'AgreementValuationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                nameEn: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('agreement-valuation', null, { reload: true });
                }, function() {
                    $state.go('agreement-valuation');
                });
            }]
        })
        .state('agreement-valuation.edit', {
            parent: 'agreement-valuation',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/agreement-valuation/agreement-valuation-dialog.html',
                    controller: 'AgreementValuationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AgreementValuation', function(AgreementValuation) {
                            return AgreementValuation.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('agreement-valuation', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('agreement-valuation.delete', {
            parent: 'agreement-valuation',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/agreement-valuation/agreement-valuation-delete-dialog.html',
                    controller: 'AgreementValuationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AgreementValuation', function(AgreementValuation) {
                            return AgreementValuation.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('agreement-valuation', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
